module.exports = __webpack_public_path__ + "img/categories-and-zones.5e1c9e77.svg";